import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { RadioButton } from 'primereact/radiobutton';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';

import moment from 'moment';

//Services
import { getAllDetails, getAllDetailsDirect, getSpecificDetailsById, postAllData } from '../../../service/ProductService';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { APP_COLLEGE, APP_COUNCIL, APP_HOSPITAL, APP_STATES, CHANGE_HOLD_UNHOLD_APPLICANT, CHECKDUPLICATE, FILEDETAIL, UPDATE_FILEDETAIL, UPLOADPROFILE, USER_HISTORY } from '../../../config/ApiConstant';
import {
    bloodGroupList,
    categoryList,
    convertDateFrom,
    DataStatusOptions,
    degreeList,
    freshApplicationName,
    freshApplicationOtherStateName,
    IMAGE_BASEURL,
    transferApplicationName,
    TRANSFERTOGUJNAME,
    VIEW_APP_CHANGE_STATUS_DROPDOWN
} from '../../../appconfig/Settings';
import { formatDate, formatDateTime, setAdminProfile, setStatusHistory } from '../../../appconfig/AppHelper';
import { DuplicateColumns } from '../../../appconfig/DatatableSetting';
import { combinedFullNameTemplate } from '../../../appconfig/DatatableTemplateSetting';
import Loader from '../../../components/Loadeer/Loader';
import { Sidebar } from 'primereact/sidebar';
import { Card } from 'primereact/card';
import { Timeline } from 'primereact/timeline';
import { Avatar } from 'primereact/avatar';
import SidebarLoader from '../../../components/Loadeer/sidebarLoader';

export const ApplicationViewForm = () => {
    document.title = 'Form Details | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);

    // Parameters
    const { fileNo }: any = useParams();

    // Navigate
    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [collegesList, setCollegesList] = useState<any>([]);
    const [statesList, setStatesList] = useState<any>([]);
    const [councilsList, setCouncilsList] = useState<any>([]);
    const [hospitalsList, setHospitalsList] = useState<any>([]);
    const [fileDetails, setFileDetails] = useState<any>({});
    const [errors, setErrors] = useState<any>({});
    const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
    const [changeAppStatusModal, setChangeAppStatusModal] = useState<boolean>(false);
    const [changeAppStatusLoader, setChangeAppStatusLoader] = useState<boolean>(false);
    const [selectedAppStatus, setSelectedAppStatus] = useState<any>(null);
    const [reason, setReason] = useState<any>('');
    const [duplicateData, setDuplicateData] = useState<any>([]);
    const [checkDuplicateModal, setCheckDuplicateModal] = useState<boolean>(false);
    const [updateLoader, setUpdateLoader] = useState<boolean>(false);
    const [editStatus, setEditStatus] = useState<boolean>(false);
    const [visibleRight, setVisibleRight] = useState(false);
    const [userHistory, setUserHistory] = useState<any>({});
    const [userHistoryApplication, setUserHistoryApplication] = useState<any>([]);
    const [historyLoad, setHistoryLoad] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        getColleges();
        getStates();
        getAllCouncil();
        getAllHospital();
        checkDuplicate();
        getFileDetails();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get colleges
    const getColleges = async () => {
        try {
            const response = await getAllDetails(APP_COLLEGE + '?type=all');
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setCollegesList([]);
                } else {
                    let collegeData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const collegeObj: any = {};
                        collegeObj['name'] = DataList[i].orgnameeng;
                        collegeObj['code'] = DataList[i].orgcode;
                        collegeData.push(collegeObj);
                    }
                    setCollegesList(collegeData);
                }
            } else {
                setCollegesList([]);
            }
        } catch (error: any) {
            setCollegesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get States
    const getStates = async () => {
        try {
            const response = await getAllDetailsDirect(APP_STATES);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setStatesList([]);
                } else {
                    let stateData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const stateObj: any = {};
                        stateObj['name'] = DataList[i].name;
                        stateObj['code'] = DataList[i].id;
                        stateData.push(stateObj);
                    }
                    setStatesList(stateData);
                }
            } else {
                setStatesList([]);
            }
        } catch (error: any) {
            setStatesList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all council
    const getAllCouncil = async () => {
        try {
            const response = await getAllDetailsDirect(APP_COUNCIL);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setCouncilsList([]);
                } else {
                    let councilData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const councilObj: any = {};
                        councilObj['name'] = DataList[i].Name;
                        councilObj['code'] = DataList[i].SrNo;
                        councilData.push(councilObj);
                    }
                    setCouncilsList(councilData);
                }
            } else {
                setCouncilsList([]);
            }
        } catch (error: any) {
            setCouncilsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all hospital
    const getAllHospital = async () => {
        try {
            const response = await getAllDetailsDirect(APP_HOSPITAL + '?type=all');
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setHospitalsList([]);
                } else {
                    let hospitalData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const hospitalObj: any = {};
                        hospitalObj['name'] = DataList[i].HospName;
                        hospitalObj['code'] = DataList[i].HospNo;
                        hospitalData.push(hospitalObj);
                    }
                    setHospitalsList(hospitalData);
                }
            } else {
                setHospitalsList([]);
            }
        } catch (error: any) {
            setHospitalsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Open check duplicate modal
    const openCheckDuplicateModal = () => {
        setCheckDuplicateModal(true);
    };

    // Close check duplicate modal
    const closeCheckDuplicateModal = () => {
        setCheckDuplicateModal(false);
    };

    // Check duplicate
    const checkDuplicate = async () => {
        try {
            const response = await getSpecificDetailsById(CHECKDUPLICATE, atob(fileNo));
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setDuplicateData([]);
                } else {
                    setDuplicateData(DataList);
                }
            }
        } catch (error: any) {
            if (error.response) {
                setChangeAppStatusLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Get file details
    const getFileDetails = async () => {
        try {
            setPageLoad(true);
            const response = await getAllDetails(FILEDETAIL + '?fileNo=' + atob(fileNo));
            if (response) {
                const { appStatus, RegCancle } = response;
                if (!window.cn(response?.HSCYr)) {
                    response['HSCYr'] = new Date(response?.HSCYr);
                }
                if (!window.cn(response?.SSCYr)) {
                    response['SSCYr'] = new Date(response?.SSCYr);
                }
                if (!window.cn(response?.JoingYth)) {
                    response['JoingYth'] = new Date(response?.JoingYth);
                }
                if (!window.cn(response?.Passedyth)) {
                    response['Passedyth'] = new Date(response?.Passedyth);
                }
                if (!window.cn(response?.OtherJoingYth) || response?.OtherJoingYth != null) {
                    response['OtherJoingYth'] = new Date(response?.OtherJoingYth);
                } else {
                    response['OtherJoingYth'] = null;
                }
                if (!window.cn(response?.OtherPassedyth)) {
                    response['OtherPassedyth'] = new Date(response?.OtherPassedyth);
                } else {
                    response['OtherPassedyth'] = null;
                }
                if (!window.cn(response?.PracTrainingJoiningYth)) {
                    response['PracTrainingJoiningYth'] = new Date(response?.PracTrainingJoiningYth);
                } else {
                    response['PracTrainingJoiningYth'] = null;
                }
                if (!window.cn(response?.PracTrainingPassedYth)) {
                    response['PracTrainingPassedYth'] = new Date(response?.PracTrainingPassedYth);
                } else {
                    response['PracTrainingPassedYth'] = null;
                }

                response['paymnetChecked'] = response?.go_for_payment;
                response['BOD'] = moment(response.BOD, 'YYYY-MM-DD').toDate();
                response['TRegDt'] = moment(response.TRegDt, 'YYYY-MM-DD').toDate();
                response['BloodGr'] = { name: response.BloodGr, code: response.BloodGr };
                response['Category'] = { name: response.Category, code: response.Category };
                response['Council'] = { name: response.TRCounCilNm, code: response.TRCouncilSrNo };
                response['Degree'] = { name: response.DegNm, code: response.DegSrNo };
                response['OtherDegree'] = { name: response.OtherDegNm, code: response.OtherDegSrNo };
                response['College'] = { name: response?.ColName, code: response?.ColSrNo };
                response['OtherCollege'] = { name: response?.OtherColName, code: response?.OtherColSrNo };
                response['State'] = { name: response.PState, code: response.PStateSrNo };
                response['POSTState'] = { name: response.postState, code: response.postStateSrNo };
                response['ACState'] = { name: response.AState, code: response.AStateSrNo };

                setFileDetails(response);

                setEditStatus(localStorage.getItem('email') == 'niketa1424@gmail.com' || localStorage.getItem('email') == 'prayer.gilbat@gmail.com' ? false : appStatus == 'Approved' || RegCancle == 1 || RegCancle == 2 ? true : false);
                setPageLoad(false);
            }
        } catch (error: any) {
            if (error.response) {
                setPageLoad(false);

                toast.current?.show({
                    severity: 'error',
                    summary: 'Alert',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (
            name === 'BOD' ||
            name === 'Gender' ||
            name === 'BloodGr' ||
            name === 'Category' ||
            name === 'State' ||
            name === 'POSTState' ||
            name === 'ACState' ||
            name === 'Degree' ||
            name === 'College' ||
            name === 'OtherDegree' ||
            name === 'OtherCollege' ||
            name === 'SSCYr' ||
            name === 'HSCYr' ||
            name === 'JoingYth' ||
            name === 'Passedyth' ||
            name === 'OtherJoingYth' ||
            name === 'OtherPassedyth' ||
            name === 'PracTrainingJoiningYth' ||
            name === 'PracTrainingPassedYth' ||
            name === 'Council' ||
            name === 'TRegDt'
        ) {
            val = e;
        } else if (name === 'electoral_status' || name === 'election_deposit_status' || name === 'nomination_status' || name === 'paymnetChecked') {
            val = e.checked === true ? 1 : 0;
        } else {
            val = (e.target && e.target.value) || e.value || '';
            if (name !== 'PEmail') {
                val = val.toUpperCase();
            }
        }
        setFileDetails({ ...fileDetails, [name]: val });
    };

    // Open view document page
    const openViewDocumentPage = () => {
        const AppName =
            fileDetails?.applicationType === 'fresh-registration'
                ? freshApplicationName
                : fileDetails?.applicationType === 'fresh-registration-other-state'
                ? freshApplicationOtherStateName
                : fileDetails?.applicationType === 'transfer-in'
                ? TRANSFERTOGUJNAME
                : fileDetails?.applicationType === 'transfer-territory'
                ? transferApplicationName
                : '';

        navigate('/app/application/viewDocument/' + btoa(fileDetails.SrNo) + '/' + btoa(AppName));
    };

    // Open change application status modal
    const openChangeAppStatusModal = () => {
        setChangeAppStatusModal(true);
    };

    // Close change application status modal
    const closeChangeAppStatusModal = () => {
        setSelectedAppStatus(null);
        setReason(null);
        setChangeAppStatusLoader(false);
        setChangeAppStatusModal(false);
    };

    // Change application status api call
    const changeAppStatusApiCall = async () => {
        try {
            setChangeAppStatusLoader(true);

            let formData: any = new FormData();
            formData.append('SrNo', atob(fileNo));
            formData.append('status', selectedAppStatus?.code);
            formData.append('RegCNote', reason);

            const response = await postAllData(CHANGE_HOLD_UNHOLD_APPLICANT, formData);
            if (response) {
                setChangeAppStatusLoader(false);
                setChangeAppStatusModal(false);
                setReason('');
                setSelectedAppStatus(null);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setTimeout(() => {
                    getFileDetails();
                }, 1500);
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setChangeAppStatusLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                setChangeAppStatusLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Go to verification list page
    const goToVerificationList = () => {
        navigate('/app/verification-list/' + fileNo);
    };

    // Open edit
    const openEdit = () => {
        setIsEditOpen(true);
    };

    const updateObject = async (obj: any) => {
        for (let key in obj) {
            if (obj[key] == 'null' || obj[key] == null) {
                obj[key] = ''; // Replace null with blank
            }
            if (obj[key] == 'Invalid date' || obj[key] == 'Invalid Date') {
                obj[key] = ''; // Replace null with blank
            }
            if (obj[key] == '0000-00-00 00:00:00.000000') {
                obj[key] = ''; // Replace null with blank
            }
        }
        // return obj;
        setFileDetails(obj);
    };

    // Update file details api call
    const updateFileDetails = async () => {
        try {
            setUpdateLoader(true);
            await updateObject(fileDetails);
            let formData: any = new FormData();
            formData.append('fileNo', Number(atob(fileNo)));

            Object.keys(fileDetails).map((item: any) => {
                if (
                    item !== 'BOD' &&
                    item !== 'Gender' &&
                    item !== 'BloodGr' &&
                    item !== 'Category' &&
                    item !== 'SSCYr' &&
                    item !== 'HSCYr' &&
                    item !== 'State' &&
                    item !== 'POSTState' &&
                    item !== 'ACState' &&
                    item !== 'Degree' &&
                    item !== 'College' &&
                    item !== 'OtherDegree' &&
                    item !== 'OtherCollege' &&
                    item !== 'user' &&
                    item !== 'created_at' &&
                    item !== 'updated_at' &&
                    item !== 'paymnetChecked' &&
                    item !== 'go_for_payment' &&
                    item !== 'OtherJoingYth' &&
                    item !== 'OtherPassedyth' &&
                    item !== 'JoingYth' &&
                    item !== 'Passedyth' &&
                    item !== 'PracTrainingJoiningYth' &&
                    item !== 'PracTrainingPassedYth' &&
                    item !== 'Council' &&
                    item !== 'TRegDt'
                ) {
                    formData.append(item, fileDetails[item]);
                }
            });

            if (fileDetails?.paymnetChecked == 1) {
                formData.append('go_for_payment', 1);
            } else {
                formData.append('go_for_payment', 0);
            }

            formData.append('SSCYr', !window.cn(fileDetails?.SSCYr) ? moment(fileDetails?.SSCYr).format('YYYY-MM') : '');
            formData.append('HSCYr', !window.cn(fileDetails?.HSCYr) ? moment(fileDetails?.HSCYr).format('YYYY-MM') : '');

            formData.append('OtherJoingYth', !window.cn(fileDetails?.OtherJoingYth) ? moment(fileDetails?.OtherJoingYth).format('YYYY-MM') : '');
            formData.append('OtherPassedyth', !window.cn(fileDetails?.OtherPassedyth) ? moment(fileDetails?.OtherPassedyth).format('YYYY-MM') : '');
            formData.append('JoingYth', !window.cn(fileDetails?.JoingYth) ? moment(fileDetails?.JoingYth).format('YYYY-MM') : '');
            formData.append('Passedyth', !window.cn(fileDetails?.Passedyth) ? moment(fileDetails?.Passedyth).format('YYYY-MM') : '');

            formData.append('PracTrainingJoiningYth', !window.cn(fileDetails?.PracTrainingJoiningYth) ? moment(fileDetails?.PracTrainingJoiningYth).format('YYYY-MM') : '');
            formData.append('PracTrainingPassedYth', !window.cn(fileDetails?.PracTrainingPassedYth) ? moment(fileDetails?.PracTrainingPassedYth).format('YYYY-MM') : '');

            formData.append('Gender', !window.cn(fileDetails?.Gender) ? fileDetails?.Gender : '');
            formData.append('BOD', !window.cn(fileDetails?.BOD) ? convertDateFrom(fileDetails?.BOD) : '');
            formData.append('TRegDt', !window.cn(fileDetails?.TRegDt) ? convertDateFrom(fileDetails?.TRegDt) : '');
            formData.append('BloodGr', !window.cn(fileDetails?.BloodGr) ? fileDetails['BloodGr']?.code : '');
            formData.append('Category', !window.cn(fileDetails?.Category) ? fileDetails['Category']?.code : '');
            formData.append('PState', !window.cn(fileDetails?.State) ? fileDetails['State']?.name : '');
            formData.append('PStateSrNo', !window.cn(fileDetails?.State) ? fileDetails['State']?.code : '');
            formData.append('postState', !window.cn(fileDetails?.POSTState) ? fileDetails['POSTState']?.name : '');
            formData.append('postStateSrNo', !window.cn(fileDetails?.POSTState) ? fileDetails['POSTState']?.code : '');
            formData.append('AState', !window.cn(fileDetails?.ACState) ? fileDetails['ACState']?.name : '');
            formData.append('AStateSrNo', !window.cn(fileDetails?.ACState) ? fileDetails['ACState']?.code : '');
            formData.append('ColName', !window.cn(fileDetails?.College) ? fileDetails['College']?.name : '');
            formData.append('ColSrNo', !window.cn(fileDetails?.College) ? fileDetails['College']?.code : '');
            formData.append('OtherColName', !window.cn(fileDetails?.OtherCollege) ? fileDetails['OtherCollege']?.name : '');
            formData.append('OtherColSrNo', !window.cn(fileDetails?.OtherCollege) ? fileDetails['OtherCollege']?.code : '');
            formData.append('DegNm', !window.cn(fileDetails?.Degree) ? fileDetails['Degree']?.name : '');
            formData.append('DegSrNo', !window.cn(fileDetails?.Degree) ? fileDetails['Degree']?.code : '');
            formData.append('OtherDegNm', !window.cn(fileDetails?.OtherDegree) ? fileDetails['OtherDegree']?.name : '');
            formData.append('OtherDegSrNo', !window.cn(fileDetails?.OtherDegree) ? fileDetails['OtherDegree']?.code : '');
            formData.append('TRCounCilNm', !window.cn(fileDetails?.Council) ? fileDetails['Council']?.name : '');
            formData.append('TRCouncilSrNo', !window.cn(fileDetails?.Council) ? fileDetails['Council']?.code : '');


            delete fileDetails['State'];
            delete fileDetails['POSTState'];
            delete fileDetails['ACState'];
            delete fileDetails['College'];
            delete fileDetails['Degree'];
            delete fileDetails['OtherDegree'];

            const response = await postAllData(UPDATE_FILEDETAIL, formData);
            if (response) {
                setUpdateLoader(false);
                getFileDetails();
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response.data.message });
            }
        } catch (error: any) {
            if (error.response) {
                setUpdateLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // New File Upload
    const onFileChange = async (event: any) => {
        /*Selected files data can be collected here.*/
        const files = event.target.files;
        //File Size Check
        const fileSize = files[0].size / 1024 / 1024;
        if (fileSize > 2) {
            alert('Please upload file size less than 2mb');
        } else {
            // Request Data
            let formData = new FormData();
            formData.append('fileNo', atob(fileNo));
            formData.append('profile_pic', files[0]);

            try {
                setPageLoad(true);
                const response = await postAllData(UPLOADPROFILE, formData);
                if (response) {
                    getFileDetails();
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Profile Picture Uploaded Successfully...' });
                }
            } catch (error) {
                setPageLoad(false);

                //Error response
                // if (error.response) {
                // }
            }
        }
    };

    const customizedMarker = (_items: any, index: any) => {
        const isLast = index === userHistoryApplication.length - 1;
        return (
            <span className={`custom-marker flex align-items-center justify-content-center text-white border-circle shadow-1 ${isLast ? 'last-marker' : ''}`} style={{ backgroundColor: 'blueviolet', height: '20px', width: '20px' }}>
                <i></i>
            </span>
        );
    };

    const customizedContent = (_items: any) => {
        let statusVal = _items?.application_name === 'Fresh Application' || _items?.application_name === 'Fresh Application Other State' || _items?.application_name === 'Transfer In' ? _items?.status : setStatusHistory(_items?.AppAccept);
        return (
            <div style={{ backgroundColor: '#ECECF9', width: '100%' }}>
                <div className="user_slider">
                    <div className="user_history">
                        <div className="fresh_app">
                            <div className="">
                                <div className="heading_div">
                                    <h3 className="heading">{_items?.application_name}</h3>
                                    <p className="status_h">
                                        {' '}
                                        Status:- <Badge value={statusVal} severity={statusVal === 'Approved' ? 'success' : statusVal === 'Rejected' ? 'danger' : 'warning'}></Badge>
                                    </p>
                                </div>
                                <div className="date_h">
                                    {_items?.application_name === 'Fresh Application' || _items?.application_name === 'Fresh Application Other State' || _items?.application_name === 'Transfer In' ? (
                                        <h6 className="year">Applied On:- {formatDate(_items?.EntDt)}</h6>
                                    ) : (
                                        <h6 className="year">Payment Date:- {formatDate(_items?.payment_date)}</h6>
                                    )}
                                    {_items?.application_name === 'Fresh Application' || _items?.application_name === 'Fresh Application Other State' || _items?.application_name === 'Transfer In' ? (
                                        <h6 className="statuses">Reg Date:- {formatDate(_items?.RegDt)}</h6>
                                    ) : (
                                        <h6 className="statuses">Payment Ref No:- {_items?.payment_ref_no}</h6>
                                    )}
                                </div>
                                {/* <span className="year">Approve Due:- Mar 05, 2025</span> */}
                                {_items?.application_name !== 'Fresh Application' && _items?.application_name !== 'Fresh Application Other State' && _items?.application_name !== 'Transfer In' && (
                                    <div className="author-area">
                                        <div className="author-img">
                                            {window.cn(_items?.verified_by) ? <Avatar icon="pi pi-user" size="xlarge" shape="circle" /> : <Avatar image={setAdminProfile(_items?.verified_by)} size="xlarge" shape="circle" />}
                                        </div>
                                        <div className="author-name-desig">
                                            <span>Verified By :- </span>
                                            <h6 className="">{!window.cn(_items?.verified_by) ? _items?.verified_by : '-'}</h6>
                                        </div>
                                    </div>
                                )}

                                {(_items?.application_name === 'Fresh Application' || _items?.application_name === 'Fresh Application Other State' || _items?.application_name === 'Transfer In') && (
                                    <div className="author-area">
                                        <div className="author-name-desig">
                                            <h6 className="mb-2">Payment Ref No : {_items?.payment_ref_no}</h6>
                                            <h6 className="">Payment Date : {formatDate(_items?.payment_date)}</h6>
                                        </div>
                                    </div>
                                )}
                                <div className="documents mt-3">
                                    <div className="document-hover-container">
                                        {_items?.application_name === 'Fresh Application' || _items?.application_name === 'Fresh Application Other State' || _items?.application_name === 'Transfer In' ? (
                                            <a href={`/app/application/viewDocument/${btoa(_items?.SrNo)}/${btoa(_items?.application_actual_name)}`} target="_blank">
                                                <Button label="View Documents" className="p-button-secondary p-button-raised"></Button>
                                            </a>
                                        ) : (
                                            <a href={`/app/application/viewOtherAppDocument/${btoa(_items?.EntryNo)}/${btoa(_items?.application_name)}/${btoa(_items?.RNo)}/${btoa(_items?.AppAccept)}`} target="_blank">
                                                <Button label="View Documents" className="p-button-secondary p-button-raised"></Button>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // Get user history api call
    const getUserHistory = async () => {
        try {
            setVisibleRight(true);
            setHistoryLoad(true);

            const response = await getAllDetailsDirect(USER_HISTORY + '?RegNo=' + fileDetails?.RegNo);
            if (response) {
                setUserHistory(response?.user_details);
                setUserHistoryApplication(response?.application_list);
                setHistoryLoad(false);
            }
        } catch (error: any) {
            if (error.response) {
                setHistoryLoad(false);
                setUserHistory({});
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

 

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb
                currentMenu={'Applications'}
                pageName={
                    fileDetails?.applicationType === 'fresh-registration'
                        ? freshApplicationName
                        : fileDetails?.applicationType === 'fresh-registration-other-state'
                        ? freshApplicationOtherStateName
                        : fileDetails?.applicationType === 'transfer-in'
                        ? TRANSFERTOGUJNAME
                        : fileDetails?.applicationType === 'transfer-territory'
                        ? transferApplicationName
                        : ''
                }
                pageTitle={
                    fileDetails?.applicationType === 'fresh-registration'
                        ? freshApplicationName
                        : fileDetails?.applicationType === 'fresh-registration-other-state'
                        ? freshApplicationOtherStateName
                        : fileDetails?.applicationType === 'transfer-in'
                        ? TRANSFERTOGUJNAME
                        : fileDetails?.applicationType === 'transfer-territory'
                        ? transferApplicationName
                        : ''
                }
                goToPage={true}
            />

            <div className="card">
                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 5 }}>
                            <Button className="p-button-secondary " label="Verification List" onClick={() => goToVerificationList()} disabled={!window.cn(fileDetails?.RegNo) ? false : true} />
                            <Button className="p-button-success " label="Change Application Status" onClick={() => openChangeAppStatusModal()} />
                            <Button label="Check Duplicate" className="p-button-primary " badge={duplicateData.length === 0 ? '0' : duplicateData.length.toString()} onClick={() => openCheckDuplicateModal()} />
                        </div>
                    </div>
                </div>
                <hr className="mt-0" />
                <div className="grid">
                    <div className="field col-12 md:col-6  grid flex-column mb-0">
                        {!window.cn(fileDetails?.SrNo) && (
                            <div className="field col-12 grid mb-3">
                                <div className="field col-12 md:col-2 mb-0">
                                    <b>File No</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-7 mb-0">{fileDetails?.SrNo}</div>
                            </div>
                        )}
                        {!window.cn(fileDetails?.user?.email) && (
                            <div className="field col-12 grid mb-3">
                                <div className="field col-12 md:col-2 mb-0">
                                    <b>User Email</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-7 mb-0">{fileDetails?.user?.email}</div>
                            </div>
                        )}
                        {!window.cn(fileDetails?.PPhone) && (
                            <div className="field col-12 grid mb-0">
                                <div className="field col-12 md:col-2 mb-0">
                                    <b>Mobile No</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-7 mb-0">{fileDetails?.PPhone}</div>
                            </div>
                        )}
                    </div>

                    <div className="field col-12 md:col-6 grid flex-column align-items-end mb-0">
                        {!window.cn(fileDetails?.RegCancle) && fileDetails?.RegCancle != 0 && fileDetails?.RegCancle != '' && fileDetails?.RegCancle != null && (
                            <div className="field col-12 grid mb-3 justify-content-end">
                                <div className="field col-12 md:col-2 mb-0">
                                    <b>Remark</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-6 mb-0 flex">
                                    {fileDetails?.RegCNote}
                                    {fileDetails?.appStatus === 'Hold' && fileDetails?.RegCancle != 2 ? <Badge severity="warning" value="Hold" className="ml-3"></Badge> : <Badge severity="danger" value="Permanently Close" className="ml-3"></Badge>}
                                </div>
                            </div>
                        )}

                        {!window.cn(fileDetails?.LastVDate) && (
                            <div className="field col-12 grid mb-3 justify-content-end">
                                <div className="field col-12 md:col-3 mb-0">
                                    <b>Last Validity</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-2 mb-0">{formatDateTime(fileDetails?.LastVDate)}</div>
                            </div>
                        )}
                        {!window.cn(fileDetails?.RegNo) && (
                            <div className="field col-12 grid mb-3 justify-content-end">
                                <div className="field col-12 md:col-3 mb-0">
                                    <b>Reg No</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-2 mb-0">{fileDetails?.RegNo}</div>
                            </div>
                        )}
                        {!window.cn(fileDetails?.RegDt) && (
                            <div className="field col-12 grid justify-content-end mb-0">
                                <div className="field col-12 md:col-3 mb-0">
                                    <b>Registration Date</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-2 mb-0">{formatDateTime(fileDetails?.RegDt)}</div>
                            </div>
                        )}
                    </div>
                </div>

                <hr />
                <p>
                    <b>Personal Details</b>
                </p>
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-3">
                        <label htmlFor="StudL">SurName</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.StudL} autoComplete="off" id="StudL" onChange={(e) => onInputChange(e, 'StudL')} className={errors['StudL'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="StudF">First Name</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.StudF} autoComplete="off" id="StudF" onChange={(e) => onInputChange(e, 'StudF')} className={errors['StudF'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="StudM">Middle Name</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.StudM} autoComplete="off" id="StudM" onChange={(e) => onInputChange(e, 'StudM')} className={errors['StudM'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-3 flex flex-column align-items-center">
                        <div className="profile-pic">
                            {isEditOpen === false ? (
                                ''
                            ) : (
                                <label className="-label" htmlFor='file"'>
                                    <span className="glyphicon glyphicon-camera"></span>
                                    <span>Change Image</span>
                                </label>
                            )}
                            <input id="file" type="file" name="upload-files[]" onChange={(e) => onFileChange(e)} accept="image/png, image/jpeg" disabled={isEditOpen === false ? true : false} />
                            <img src={!window.cn(fileDetails?.Image) ? fileDetails?.Image : IMAGE_BASEURL + 'no-image.jpg'} id="output" className="img-fluid" />
                        </div>
                        {!window.cn(fileDetails?.RegNo) && fileDetails?.RegNo != 'null' && fileDetails?.RegCancle == 0 && (
                            <Button style={{ width: 'auto' }} icon="pi pi-sync" tooltip="History" label="User History" onClick={() => getUserHistory()} className="mt-3" />
                        )}
                        {/* View 360° */}
                        {/* {!window.cn(fileDetails?.Image) && <Image style={{ float: 'right' }} src={fileDetails?.Image} alt="Image" width="150" />} */}
                    </div>
                </div>

                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label htmlFor="StudM">Alias Name</label>
                        <div className="input-effect-div">
                            <InputText
                                value={fileDetails?.NameChange}
                                autoComplete="off"
                                id="NameChange"
                                onChange={(e) => onInputChange(e, 'NameChange')}
                                className={errors['NameChange'] && 'p-invalid'}
                                disabled={isEditOpen === false ? true : false}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                </div>

                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-4">
                        <label htmlFor="gender" className="mb-3">
                            Gender
                        </label>
                        <div className="grid">
                            <div className="col-12 md:col-4 lg:col-4">
                                <div className="field-radiobutton">
                                    <RadioButton inputId="option1" name="option" value="Male" checked={fileDetails.Gender === 'Male'} onChange={(e) => onInputChange(e.value, 'Gender')} disabled={isEditOpen === false ? true : false} />
                                    <label htmlFor="option1">Male</label>
                                </div>
                            </div>
                            <div className="col-12 md:col-4 lg:col-4">
                                <div className="field-radiobutton">
                                    <RadioButton inputId="option2" name="option" value="Female" checked={fileDetails.Gender === 'Female'} onChange={(e) => onInputChange(e.value, 'Gender')} disabled={isEditOpen === false ? true : false} />
                                    <label htmlFor="option2">Female</label>
                                </div>
                            </div>
                            <div className="col-12 md:col-4 lg:col-4">
                                <div className="field-radiobutton">
                                    <RadioButton inputId="option2" name="option" value="Other" checked={fileDetails.Gender === 'Other'} onChange={(e) => onInputChange(e.value, 'Gender')} disabled={isEditOpen === false ? true : false} />
                                    <label htmlFor="option2">Other</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="BOD">Birth Date</label>
                        <Calendar value={!window.cn(fileDetails?.BOD) && fileDetails?.BOD} onChange={(e) => onInputChange(e.value, 'BOD')} dateFormat="dd-M-yy" disabled={isEditOpen === false ? true : false} />
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="BOD">Birth Place</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.PofBOD} autoComplete="off" id="PofBOD" onChange={(e) => onInputChange(e, 'PofBOD')} className={errors['PofBOD'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="BloodGr">Blood Group</label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={fileDetails?.BloodGr}
                                name="BloodGr"
                                options={bloodGroupList}
                                filter
                                optionLabel="name"
                                placeholder="Select Blood Group"
                                onChange={(e) => onInputChange(e.value, 'BloodGr')}
                                className={errors['BloodGr'] && 'p-invalid'}
                                disabled={isEditOpen === false ? true : false}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="Nationality">Nationality</label>
                        <div className="input-effect-div">
                            <InputText
                                value={fileDetails?.Nationality}
                                autoComplete="off"
                                id="Nationality"
                                onChange={(e) => onInputChange(e, 'Nationality')}
                                className={errors['Nationality'] && 'p-invalid'}
                                disabled={isEditOpen === false ? true : false}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="Religion">Religion</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.Religion} autoComplete="off" id="Religion" onChange={(e) => onInputChange(e, 'Religion')} className={errors['Religion'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="Category">Category</label>
                        <div className="input-effect-div">
                            <Dropdown
                                value={fileDetails?.Category}
                                name="Category"
                                options={categoryList}
                                filter
                                optionLabel="name"
                                placeholder="Select Category"
                                onChange={(e) => onInputChange(e.value, 'Category')}
                                className={errors['Category'] && 'p-invalid'}
                                disabled={isEditOpen === false ? true : false}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="AadharCard">Aadhar No.</label>
                        <div className="input-effect-div">
                            <InputText
                                value={fileDetails?.AadharCard}
                                autoComplete="off"
                                id="AadharCard"
                                onChange={(e) => onInputChange(e, 'AadharCard')}
                                className={errors['AadharCard'] && 'p-invalid'}
                                disabled={isEditOpen === false ? true : false}
                            />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="PanCard">Pan No.</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.PanCard} autoComplete="off" id="PanCard" onChange={(e) => onInputChange(e, 'PanCard')} className={errors['PanCard'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>

                    {(fileDetails?.applicationType === 'transfer-in' || fileDetails?.applicationType === 'transfer-territory') && (
                        <>
                            <div className="field col-12 md:col-4">
                                <label htmlFor="TRCounCilNm">Council</label>
                                <div className="input-effect-div">
                                    <Dropdown
                                        value={fileDetails?.Council}
                                        name="Council"
                                        options={councilsList}
                                        filter
                                        optionLabel="name"
                                        placeholder="Select Council"
                                        onChange={(e) => onInputChange(e.value, 'Council')}
                                        className={errors['Council'] && 'p-invalid'}
                                        disabled={isEditOpen === false ? true : false}
                                    />
                                    <span className="focus-bg"></span>
                                </div>
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="TRegNo">Registartion No.</label>
                                <div className="input-effect-div">
                                    <InputText value={fileDetails?.TRegNo} autoComplete="off" id="TRegNo" onChange={(e) => onInputChange(e, 'TRegNo')} className={errors['TRegNo'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                    <span className="focus-bg"></span>
                                </div>
                            </div>

                            <div className="field col-12 md:col-4">
                                <label htmlFor="TRegDt">Date of Registration</label>
                                <Calendar value={!window.cn(fileDetails?.TRegDt) && fileDetails?.TRegDt} dateFormat="dd-M-yy" onChange={(e) => onInputChange(e.value, 'TRegDt')} disabled={isEditOpen === false ? true : false} />
                            </div>
                        </>
                    )}
                </div>
                <hr />
                <p>
                    <b>Contact</b>
                </p>
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-4">
                        <label htmlFor="PPhone">Mobile No</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.PPhone} autoComplete="off" id="PPhone" onChange={(e) => onInputChange(e, 'PPhone')} className={errors['PPhone'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="APhone">Second Mobile No</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.APhone} autoComplete="off" id="APhone" onChange={(e) => onInputChange(e, 'APhone')} className={errors['APhone'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                    <div className="field col-12 md:col-4">
                        <label htmlFor="PEmail">Email</label>
                        <div className="input-effect-div">
                            <InputText value={fileDetails?.PEmail} autoComplete="off" id="PEmail" onChange={(e) => onInputChange(e, 'PEmail')} className={errors['PEmail'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                            <span className="focus-bg"></span>
                        </div>
                    </div>
                </div>
                <hr />

                <p>
                    <b>Educational Details</b>
                </p>
                <div className="p-fluid formgrid grid">
                    <div className="col-12 md:col-6">
                        <p>
                            <b>SSC</b>
                        </p>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="SSCSNm">School Name</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.SSCSNm} autoComplete="off" id="SSCSNm" onChange={(e) => onInputChange(e, 'SSCSNm')} className={errors['SSCSNm'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="SSCYr">Passed Year</label>
                            {/* <div className="input-effect-div">
                                <InputText value={fileDetails?.SSCYr} autoComplete="off" id="SSCYr" onChange={(e) => onInputChange(e, 'SSCYr')} className={errors['SSCYr'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div> */}
                            <Calendar view="month" value={!window.cn(fileDetails?.SSCYr) ? fileDetails?.SSCYr : new Date('')} onChange={(e) => onInputChange(e.value, 'SSCYr')} dateFormat="yy-mm" disabled={isEditOpen === false ? true : false} />
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="SSCBrd">Board</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.SSCBrd} autoComplete="off" id="SSCBrd" onChange={(e) => onInputChange(e, 'SSCBrd')} className={errors['SSCBrd'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 md:col-6">
                        <p>
                            <b>HSC</b>
                        </p>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="HSCSNm">School Name</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.HSCSNm} autoComplete="off" id="HSCSNm" onChange={(e) => onInputChange(e, 'HSCSNm')} className={errors['HSCSNm'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="HSCYr">Passed Year</label>
                            {/* <div className="input-effect-div">
                                <InputText value={fileDetails?.HSCYr} autoComplete="off" id="HSCYr" onChange={(e) => onInputChange(e, 'HSCYr')} className={errors['HSCYr'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div> */}
                            <Calendar view="month" value={!window.cn(fileDetails?.HSCYr) ? fileDetails?.HSCYr : new Date('')} onChange={(e) => onInputChange(e.value, 'HSCYr')} dateFormat="yy-mm" disabled={isEditOpen === false ? true : false} />
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="HSCBrd">Board</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.HSCBrd} autoComplete="off" id="HSCBrd" onChange={(e) => onInputChange(e, 'HSCBrd')} className={errors['HSCBrd'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div className="p-fluid formgrid grid">
                    <div className="col-12 md:col-6">
                        <p>
                            <b>College</b>
                        </p>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="Degree">Qualification</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.Degree}
                                    name="Degree"
                                    options={degreeList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select Degree"
                                    onChange={(e) => onInputChange(e.value, 'Degree')}
                                    className={errors['Degree'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="College">College Name</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.College}
                                    name="College"
                                    options={collegesList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select College"
                                    onChange={(e) => onInputChange(e.value, 'College')}
                                    className={errors['College'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="JoingYth">Joining Year</label>
                            {/* <div className="input-effect-div">
                                <InputText value={fileDetails?.JoingYth} autoComplete="off" id="JoingYth" onChange={(e) => onInputChange(e, 'JoingYth')} className={errors['JoingYth'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div> */}
                            <Calendar view="month" value={!window.cn(fileDetails?.JoingYth) ? fileDetails?.JoingYth : null} onChange={(e) => onInputChange(e.value, 'JoingYth')} dateFormat="yy-mm" disabled={isEditOpen === false ? true : false} />
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="Passedyth">Passed Year</label>
                            {/* <div className="input-effect-div">
                                <InputText
                                    value={fileDetails?.Passedyth}
                                    autoComplete="off"
                                    id="Passedyth"
                                    onChange={(e) => onInputChange(e, 'Passedyth')}
                                    className={errors['Passedyth'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                                <span className="focus-bg"></span>
                            </div> */}
                            <Calendar view="month" value={!window.cn(fileDetails?.Passedyth) ? fileDetails?.Passedyth : null} onChange={(e) => onInputChange(e.value, 'Passedyth')} dateFormat="yy-mm" disabled={isEditOpen === false ? true : false} />
                        </div>

                        {fileDetails?.Degree?.name === 'D Pharm' ? (
                            <>
                                <div className="field col-12 md:col-12">
                                    <label htmlFor="PracTrainingQual">Practical Training</label>
                                    <div className="input-effect-div">
                                        <InputText
                                            value={fileDetails?.PracTrainingQual}
                                            autoComplete="off"
                                            id="PracTrainingQual"
                                            onChange={(e) => onInputChange(e, 'PracTrainingQual')}
                                            className={errors['PracTrainingQual'] && 'p-invalid'}
                                            disabled={isEditOpen === false ? true : false}
                                        />
                                        <span className="focus-bg"></span>
                                    </div>
                                </div>
                                <div className="field col-12 md:col-12">
                                    <label htmlFor="PracTrainingJoiningYth">Practical Joining Year</label>

                                    <Calendar
                                        view="month"
                                        value={!window.cn(fileDetails?.PracTrainingJoiningYth) ? fileDetails?.PracTrainingJoiningYth : null}
                                        onChange={(e) => onInputChange(e.value, 'PracTrainingJoiningYth')}
                                        dateFormat="yy-mm"
                                        disabled={isEditOpen === false ? true : false}
                                    />
                                </div>
                                <div className="field col-12 md:col-12">
                                    <label htmlFor="PracTrainingPassedYth">Practical Passing Year</label>

                                    <Calendar
                                        view="month"
                                        value={!window.cn(fileDetails?.PracTrainingPassedYth) ? fileDetails?.PracTrainingPassedYth : null}
                                        onChange={(e) => onInputChange(e.value, 'PracTrainingPassedYth')}
                                        dateFormat="yy-mm"
                                        disabled={isEditOpen === false ? true : false}
                                    />
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>

                    <div className="col-12 md:col-6">
                        <p>
                            <b>Other College</b>
                        </p>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="OtherDegree">Qualification</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.OtherDegree}
                                    name="OtherDegree"
                                    options={degreeList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select Degree"
                                    onChange={(e) => onInputChange(e.value, 'OtherDegree')}
                                    className={errors['OtherDegree'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="OtherCollege">College Name</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.OtherCollege}
                                    name="OtherCollege"
                                    options={collegesList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select College"
                                    onChange={(e) => onInputChange(e.value, 'OtherCollege')}
                                    className={errors['OtherCollege'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="OtherJoingYth">Joining Year</label>

                            <Calendar
                                view="month"
                                value={!window.cn(fileDetails?.OtherJoingYth) ? fileDetails?.OtherJoingYth : null}
                                onChange={(e) => onInputChange(e.value, 'OtherJoingYth')}
                                dateFormat="yy-mm"
                                disabled={isEditOpen === false ? true : false}
                            />
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="OtherPassedyth">Passed Year</label>

                            <Calendar
                                view="month"
                                value={!window.cn(fileDetails?.OtherPassedyth) ? fileDetails?.OtherPassedyth : null}
                                onChange={(e) => onInputChange(e.value, 'OtherPassedyth')}
                                dateFormat="yy-mm"
                                disabled={isEditOpen === false ? true : false}
                            />
                        </div>

                        {fileDetails?.OtherDegree?.code === 'D Pharm' ? (
                            <>
                                <div className="field col-12 md:col-12">
                                    <label htmlFor="PracTrainingOther">Practical Training</label>
                                    <div className="input-effect-div">
                                        <InputText
                                            value={fileDetails?.PracTrainingOther}
                                            autoComplete="off"
                                            id="PracTrainingOther"
                                            onChange={(e) => onInputChange(e, 'PracTrainingOther')}
                                            className={errors['PracTrainingOther'] && 'p-invalid'}
                                            disabled={isEditOpen === false ? true : false}
                                        />
                                        <span className="focus-bg"></span>
                                    </div>
                                </div>
                                <div className="field col-12 md:col-12">
                                    <label htmlFor="PracTrainingJoiningYth">Practical Joining Year</label>

                                    <Calendar
                                        view="month"
                                        value={!window.cn(fileDetails?.PracTrainingJoiningYth) ? fileDetails?.PracTrainingJoiningYth : null}
                                        onChange={(e) => onInputChange(e.value, 'PracTrainingJoiningYth')}
                                        dateFormat="yy-mm"
                                        disabled={isEditOpen === false ? true : false}
                                    />
                                </div>
                                <div className="field col-12 md:col-12">
                                    <label htmlFor="PracTrainingPassedYth">Practical Passing Year</label>
                                    {/* <div className="input-effect-div">
                                        <InputText
                                            value={fileDetails?.PracTrainingPassedYth}
                                            autoComplete="off"
                                            id="PracTrainingPassedYth"
                                            onChange={(e) => onInputChange(e, 'PracTrainingPassedYth')}
                                            className={errors['PracTrainingPassedYth'] && 'p-invalid'}
                                            disabled={isEditOpen === false ? true : false}
                                        />
                                        <span className="focus-bg"></span>
                                    </div> */}

                                    <Calendar
                                        view="month"
                                        value={!window.cn(fileDetails?.PracTrainingPassedYth) ? fileDetails?.PracTrainingPassedYth : null}
                                        onChange={(e) => onInputChange(e.value, 'PracTrainingPassedYth')}
                                        dateFormat="yy-mm"
                                        disabled={isEditOpen === false ? true : false}
                                    />
                                </div>
                            </>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
                <hr />
                <p>
                    <b>Communication Details</b>
                </p>
                <div className="p-fluid formgrid grid">
                    <div className="col-12 md:col-4">
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PAddress">Present Address</label>
                            <div className="input-effect-div">
                                <InputTextarea
                                    rows={5}
                                    cols={30}
                                    value={fileDetails?.PAddress}
                                    autoComplete="off"
                                    id="PAddress"
                                    onChange={(e) => onInputChange(e, 'PAddress')}
                                    className={errors['PAddress'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PState">State</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.State}
                                    name="PState"
                                    options={statesList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select State"
                                    onChange={(e) => onInputChange(e.value, 'State')}
                                    className={errors['PState'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PDist">District</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.PDist} autoComplete="off" id="PDist" onChange={(e) => onInputChange(e, 'PDist')} className={errors['PDist'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PTaluka">Taluka</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.PTaluka} autoComplete="off" id="PTaluka" onChange={(e) => onInputChange(e, 'PTaluka')} className={errors['PTaluka'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PCity">City</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.PCity} autoComplete="off" id="PCity" onChange={(e) => onInputChange(e, 'PCity')} className={errors['PCity'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="PPIN">Pin Code</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.PPIN} autoComplete="off" id="PPIN" onChange={(e) => onInputChange(e, 'PPIN')} className={errors['PPIN'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 md:col-4">
                        <div className="field col-12 md:col-12">
                            <label htmlFor="postAddress">Post Address</label>
                            <div className="input-effect-div">
                                <InputTextarea
                                    rows={5}
                                    cols={30}
                                    value={fileDetails?.postAddress}
                                    autoComplete="off"
                                    id="postAddress"
                                    onChange={(e) => onInputChange(e, 'postAddress')}
                                    className={errors['postAddress'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="postState">State</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.POSTState}
                                    name="postState"
                                    options={statesList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select State"
                                    onChange={(e) => onInputChange(e.value, 'POSTState')}
                                    className={errors['postState'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="postDist">District</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.postDist} autoComplete="off" id="postDist" onChange={(e) => onInputChange(e, 'postDist')} className={errors['postDist'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="postTaluka">Taluka</label>
                            <div className="input-effect-div">
                                <InputText
                                    value={fileDetails?.postTaluka}
                                    autoComplete="off"
                                    id="postTaluka"
                                    onChange={(e) => onInputChange(e, 'postTaluka')}
                                    className={errors['postTaluka'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="postCity">City</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.postCity} autoComplete="off" id="postCity" onChange={(e) => onInputChange(e, 'postCity')} className={errors['postCity'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="postPIN">Pin Code</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.postPIN} autoComplete="off" id="postPIN" onChange={(e) => onInputChange(e, 'postPIN')} className={errors['postPIN'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 md:col-4">
                        <div className="field col-12 md:col-12">
                            <label htmlFor="AAddress">Professional Address</label>
                            <div className="input-effect-div">
                                <InputTextarea
                                    rows={5}
                                    cols={30}
                                    value={fileDetails?.AAddress}
                                    autoComplete="off"
                                    id="AAddress"
                                    onChange={(e) => onInputChange(e, 'AAddress')}
                                    className={errors['AAddress'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="AState">State</label>
                            <div className="input-effect-div">
                                <Dropdown
                                    value={fileDetails?.ACState}
                                    name="AState"
                                    options={statesList}
                                    filter
                                    optionLabel="name"
                                    placeholder="Select State"
                                    onChange={(e) => onInputChange(e.value, 'ACState')}
                                    className={errors['AState'] && 'p-invalid'}
                                    disabled={isEditOpen === false ? true : false}
                                />
                            </div>
                            <span className="focus-bg"></span>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="ADist">District</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.ADist} autoComplete="off" id="ADist" onChange={(e) => onInputChange(e, 'ADist')} className={errors['ADist'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="ATaluka">Taluka</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.ATaluka} autoComplete="off" id="ATaluka" onChange={(e) => onInputChange(e, 'ATaluka')} className={errors['ATaluka'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="ACity">City</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.ACity} autoComplete="off" id="ACity" onChange={(e) => onInputChange(e, 'ACity')} className={errors['ACity'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                        <div className="field col-12 md:col-12">
                            <label htmlFor="APIN">Pin Code</label>
                            <div className="input-effect-div">
                                <InputText value={fileDetails?.APIN} autoComplete="off" id="APIN" onChange={(e) => onInputChange(e, 'APIN')} className={errors['APIN'] && 'p-invalid'} disabled={isEditOpen === false ? true : false} />
                                <span className="focus-bg"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-fluid formgrid grid">
                    {fileDetails.applicationType && fileDetails.applicationType != 'fresh-registration' && fileDetails?.go_for_payment != 2 && (
                        <div className="field col-12 md:col-4 align-items-center flex">
                            <Checkbox
                                inputId="Allow-Payment"
                                name="Allow Payment"
                                value="Allow Payment"
                                checked={fileDetails?.paymnetChecked === 1 ? true : false}
                                onChange={(e) => onInputChange(e, 'paymnetChecked')}
                                disabled={isEditOpen === false ? true : false}
                                className="ml-2"
                            />
                            <label htmlFor="PracTrainingQual " className="ml-2 mb-0">
                                {' '}
                                Allow Payment
                            </label>
                        </div>
                    )}

                    <div className="field col-12 md:col-4 align-items-center flex">
                        <Checkbox
                            inputId="Electoral-Roll-Fees"
                            name="Electoral Roll Fees"
                            value="Electoral Roll Fees"
                            checked={fileDetails?.electoral_status === 1 ? true : false}
                            onChange={(e) => onInputChange(e, 'electoral_status')}
                            disabled={isEditOpen === false ? true : false}
                            className="ml-2"
                        />
                        <label htmlFor="Electoral-Roll-Fees" className="ml-2 mb-0">
                            Electoral Roll Fees
                        </label>
                    </div>

                    <div className="field col-12 md:col-4 align-items-center flex">
                        <Checkbox
                            inputId="Election-Deposit"
                            name="Election Deposit"
                            value="Election Deposit"
                            checked={fileDetails?.election_deposit_status === 1 ? true : false}
                            onChange={(e) => onInputChange(e, 'election_deposit_status')}
                            disabled={isEditOpen === false ? true : false}
                            className="ml-2"
                        />

                        <label htmlFor="Election-Deposit" className="ml-2 mb-0">
                            Election Deposit
                        </label>
                    </div>
                    <div className="field col-12 md:col-4 align-items-center flex">
                        <Checkbox
                            inputId="Nominaion-Form-Fees"
                            name="Nominaion Form Fees"
                            value="Nominaion Form Fees"
                            checked={fileDetails?.nomination_status === 1 ? true : false}
                            onChange={(e) => onInputChange(e, 'nomination_status')}
                            disabled={isEditOpen === false ? true : false}
                            className="ml-2"
                        />
                        <label htmlFor="Nominaion-Form-Fees" className="ml-2 mb-0">
                            Nominaion Form Fees
                        </label>
                    </div>
                </div>

                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                            <Button icon="pi pi-caret-right" className="p-button-secondary mr-2" label="Next" onClick={openViewDocumentPage} disabled={editStatus} />
                            <Button icon="pi pi-pencil" label={isEditOpen ? 'Update' : 'Edit'} onClick={isEditOpen ? () => updateFileDetails() : () => openEdit()} loading={updateLoader} disabled={editStatus} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Change Application Status Dialog */}
            <Dialog
                visible={changeAppStatusModal}
                className="p-fluid"
                style={{ width: '100vh' }}
                header="Change Application Status"
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeChangeAppStatusModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => changeAppStatusApiCall()} loading={changeAppStatusLoader} />
                    </>
                }
                onHide={closeChangeAppStatusModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="name">
                            Select Status <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown
                            value={selectedAppStatus}
                            name="appStatus"
                            options={VIEW_APP_CHANGE_STATUS_DROPDOWN}
                            filter
                            optionLabel="name"
                            placeholder="Select Status"
                            onChange={(e) => setSelectedAppStatus(e.value)}
                            className={errors['appStatus'] && 'p-invalid'}
                        />
                        <small className="p-invalid-txt">{errors['appStatus']}</small>
                    </div>
                    <div className="field col-12">
                        <label htmlFor="name">
                            Reason <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText value={reason} name="reason" autoComplete="off" placeholder="Enter Reason" onChange={(e) => setReason(e.target.value)} className={errors['reason'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['reason']}</small>
                    </div>
                </div>
            </Dialog>

            {/* Check Duplicate Dialog */}
            <Dialog visible={checkDuplicateModal} className="p-fluid" style={{ width: '100vh' }} header="Check Duplicate" modal draggable={false} resizable={false} onHide={closeCheckDuplicateModal} footer={<></>}>
                <DataTable value={duplicateData} showGridlines stripedRows className="datatable-responsive p-datatable-sm" emptyMessage="No Duplicates Found">
                    {DuplicateColumns.map((col, i) => {
                        if (col.field === 'full_name') {
                            return <Column key={col.field} field={col.field} header={col.header} body={combinedFullNameTemplate} />;
                        } else {
                            return <Column key={col.field} field={col.field} header={col.header} />;
                        }
                    })}
                </DataTable>
            </Dialog>

            <Sidebar className="user_sidebar" baseZIndex={1000000} visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
                {historyLoad ? (
                    <SidebarLoader />
                ) : (
                    <div className="user_history">
                        <h3 className="mb-4">
                            {/* <span style={{ color: '#333', marginRight: '10px' }}>Name :</span> */}
                            {!window.cn(userHistory) ? userHistory?.name : ''}
                        </h3>
                        <div className="flex justify-content-between">
                            <div>
                                <h6 className="mb-0">
                                    <span style={{ color: '#333', marginRight: '10px' }}>File No :</span>
                                    {!window.cn(userHistory) ? userHistory?.file_no : ''}
                                </h6>
                                <h6 className="mb-0 mt-2">
                                    <span style={{ color: '#333', marginRight: '10px' }}>RegNo :</span>
                                    {!window.cn(userHistory) ? userHistory?.reg_no : ''}
                                </h6>
                                {!window.cn(userHistory?.email) && (
                                    <h6 className="mb-0 mt-2">
                                        <span style={{ color: '#333', marginRight: '10px' }}>User Email :</span>
                                        {!window.cn(userHistory) ? userHistory?.email : ''}
                                    </h6>
                                )}
                            </div>
                            <div>
                                <h6 className="mb-0">
                                    <span style={{ color: '#333', marginRight: '10px' }}>Validity :</span>
                                    {!window.cn(userHistory) ? formatDate(userHistory?.validity) : ''}
                                </h6>
                                {!window.cn(userHistory?.mobile) && (
                                    <h6 className="mb-0 mt-2">
                                        <span style={{ color: '#333', marginRight: '10px' }}>User Phone :</span>
                                        {!window.cn(userHistory) ? userHistory?.mobile : ''}
                                    </h6>
                                )}
                            </div>
                        </div>

                        <Card className="history_content card_animation" style={{ backgroundColor: 'ECECF9', marginTop: '30px' }}>
                            <Timeline value={userHistoryApplication} className="customized-timeline timeline_chage" marker={(_items, index) => customizedMarker(_items, index)} content={customizedContent} />
                        </Card>
                    </div>
                )}
            </Sidebar>

            {pageLoad && <Loader />}
        </>
    );
};
